import api from './api'

const hubUserInvitationsAPI = {
  // Create hub user invitation
  create: async (invitationData) => {
    // Include window.location.origin (like copy invitation link)
    const dataWithOrigin = {
      ...invitationData,
      frontend_url: window.location.origin || 'http://localhost:3000'
    }
    const response = await api.post('/hub-user-invitations', dataWithOrigin)
    return response.data
  },

  // Get all hub user invitations
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams()
    if (params.status) queryParams.append('status', params.status)
    
    const response = await api.get(`/hub-user-invitations?${queryParams.toString()}`)
    return response.data
  },

  // Validate invitation token (public route)
  validate: async (token) => {
    const response = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:5000'}/api/hub-user-invitations/validate/${token}`)
    return response.json()
  },

  // Accept invitation and register (public route)
  accept: async (token, userData) => {
    const response = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:5000'}/api/hub-user-invitations/accept/${token}/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData)
    })
    return response.json()
  },

  // Cancel invitation
  cancel: async (invitationId) => {
    const response = await api.put(`/hub-user-invitations/${invitationId}/cancel`)
    return response.data
  },

  // Delete invitation
  delete: async (invitationId) => {
    const response = await api.delete(`/hub-user-invitations/${invitationId}`)
    return response.data
  }
}

export default hubUserInvitationsAPI

